// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiHandlerDiscreteParameter, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import {
    RemoveCartLineApiParameter,
    removeCartLineWithResult as removeCartLineApi,
} from "@insite/client-framework/Services/CartService";
import {
    chain,
    DispatchCompleteRemoveCartLine,
} from "@insite/client-framework/Store/Pages/Cart/Handlers/RemoveCartLine";
import translate from "@insite/client-framework/Translate";
import { removeShippingInformation } from "@tps/App/Services/CartService";

type HandlerType = ApiHandlerDiscreteParameter<
    {
        cartLineId: string;
        warehouseId?: string;
    },
    RemoveCartLineApiParameter
>;

export const RemoveWarehouseShippingInfo: HandlerType = async props => {
    if (props.parameter.warehouseId) {
        try {
            props.dispatch({
                type: "xShippingDetails/DeleteShippingDetails",
                warehouseId: props.parameter.warehouseId,
            } as any);
            await removeShippingInformation([props.parameter.warehouseId]);

        } catch (error) {
            return false;
        }
    }
};

addToChainAfter(chain, DispatchCompleteRemoveCartLine, RemoveWarehouseShippingInfo);
